// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyAb-RMLaGAuvWtFk1Z0TtBwIjbbEYHG8Ao",
    authDomain: "happy-hours-tlv-18664.firebaseapp.com",
    projectId: "happy-hours-tlv-18664",
    storageBucket: "happy-hours-tlv-18664.firebasestorage.app",
    messagingSenderId: "71500409406",
    appId: "1:71500409406:web:5cd0cb868091c921e6bf6f",
    measurementId: "G-27S5JLQ3FV"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, storage, googleProvider };